import React from 'react';
import { Helmet } from 'react-helmet';
import JsonLdList from '../../../common/seo/JsonLdList';
import { DEFAULT_OG_IMAGE, SITE_URL, organizationSchema, websiteSchema } from '../../../../utils/seo';
import { buildFaqSchema, buildItemListSchema, buildWebPageSchema } from '../../../../utils/schema';
import pageAssets from '../../../../data/pageAssets';

const HomeSeo = ({ seo, productCards, faqItems, shareImageKey }) => {
    const shareImage = shareImageKey ? `${SITE_URL}${pageAssets[shareImageKey]}` : DEFAULT_OG_IMAGE;
    const schemas = [
        organizationSchema,
        websiteSchema,
        buildWebPageSchema({
            name: seo.webPageName,
            url: `${SITE_URL}/`,
            description: seo.webPageDescription,
            about: [
                { "@type": "Thing", "name": "Electrical cable", "sameAs": "https://www.wikidata.org/wiki/Q188447" },
                { "@type": "Thing", "name": "Ceiling fan", "sameAs": "https://www.wikidata.org/wiki/Q1181944" },
                { "@type": "Thing", "name": "Christmas lights", "sameAs": "https://www.wikidata.org/wiki/Q1653073" }
            ],
            speakable: ['.home-intro', '.global-features', '.combined-faq']
        }),
        buildItemListSchema({
            name: 'NISHAD Product Categories',
            items: productCards,
            getName: (card) => card.titleHighlight,
            getUrl: (card) => `${SITE_URL}${card.learnRoute}`
        }),
        buildFaqSchema(faqItems)
    ];

    return (
        <>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Nishad Cables" />
                <link rel="canonical" href={`${SITE_URL}/`} />

                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${SITE_URL}/`} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.ogDescription} />
                <meta property="og:image" content={shareImage} />
                <meta property="og:image:alt" content={seo.imageAlt} />
                <meta property="og:site_name" content="NISHAD" />
                <meta property="og:locale" content="en_IN" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:url" content={`${SITE_URL}/`} />
                <meta name="twitter:title" content={seo.title} />
                <meta name="twitter:description" content={seo.twitterDescription} />
                <meta name="twitter:image" content={shareImage} />
            </Helmet>
            <JsonLdList items={schemas} />
        </>
    );
};

export default HomeSeo;

